const addressFragment = `
    id
    address1
    address2
    city
    country
    province
    zip
    name
    firstName
    lastName
    phoneNumber
    territoryCode
`

const query = `query {
    customer {
        firstName
        lastName
        creationDate
        id
        emailAddress {
            emailAddress
        }
        phoneNumber {
            phoneNumber
        }
        addresses (first: 10) {
            edges {
                node {
                    ${addressFragment}
                }
            }
        }
        defaultAddress {
            ${addressFragment}
        }
        orders (first: 20, reverse: true) {
            edges {
                node {
                    id
                    name
                    number
                    createdAt
                    updatedAt
                    cancelledAt
                    fulfillments (first: 10) {
                        edges {
                            node {
                                id
                                estimatedDeliveryAt
                                fulfillmentLineItems (first: 10) {
                                    edges {
                                        node {
                                            quantity
                                            lineItem {
                                                discountAllocations {
                                                    allocatedAmount {
                                                        amount
                                                    }
                                                    discountApplication {
                                                        ... on DiscountCodeApplication {
                                                            code
                                                        }
                                                    }
                                            
                                                }
                                                currentTotalPrice {
                                                    amount
                                                    currencyCode
                                                }
                                                customAttributes {
                                                    key
                                                    value
                                                }
                                                image {
                                                    url
                                                    width
                                                    height
                                                }
                                                price {
                                                    amount
                                                    currencyCode
                                                }
                                                productType
                                                productId
                                                quantity
                                                title
                                            }
                                        }
                                    }
                                }
                                latestShipmentStatus
                                status
                                updatedAt
                                trackingInformation {
                                    company
                                    number
                                    url
                                }
                            }
                        }
                    }
                    lineItems (first: 10) {
                        edges {
                            node {
                                id
                                image {
                                    url
                                }
                                totalDiscount {
                                    amount
                                    currencyCode
                                }
                                currentTotalPrice {
                                    amount
                                    currencyCode
                                }
                                price {
                                    amount
                                    currencyCode
                                }
                                quantity
                                variantId
                                title
                                productType
                                customAttributes {
                                    key
                                    value
                                }
                            }
                        }
                    }
                    shippingAddress {
                        address1
                        address2
                        city
                        company
                        country
                        firstName
                        formatted
                        formattedArea
                        lastName
                        name
                        phoneNumber
                        province
                        zip
                    }
                    billingAddress {
                        address1
                        address2
                        city
                        company
                        country
                        firstName
                        formatted
                        formattedArea
                        lastName
                        name
                        phoneNumber
                        province
                        zip
                    }
                    refunds {
                        createdAt
                    }
                    totalPrice {
                        amount
                        currencyCode
                    }
                    subtotal {
                        amount
                        currencyCode
                    }
                    totalShipping {
                        amount
                        currencyCode
                    }
                    totalRefunded {
                        amount
                        currencyCode
                    }
                    transactions {
                        status
                        paymentDetails {
                            ... on CardPaymentDetails {
                                cardBrand
                                last4
                            }
                        }
                        paymentIcon {
                            url
                            height
                            altText
                        }
                    }
                }
            }
        }
    }
}`

export default query
